import RcCalendar from 'rc-calendar';
import MonthCalendar from 'rc-calendar/lib/MonthCalendar';
import createPicker from './createPicker';
import wrapPicker from './wrapPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';
import RangePickerButton from './RangePickerButton';
const DatePicker = wrapPicker(createPicker(RcCalendar), 'date');
const MonthPicker = wrapPicker(createPicker(MonthCalendar), 'month');
Object.assign(DatePicker, {
    RangePicker: wrapPicker(RangePicker, 'date'),
    RangePickerButton: wrapPicker(RangePickerButton, 'date'),
    MonthPicker,
    WeekPicker: wrapPicker(WeekPicker, 'week'),
});
export default DatePicker;
